import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, HeartIcon, BookOpenIcon } from 'lucide-react';
export function FooterSection() {
  const scrollToPrecios = () => {
    const element = document.querySelector('#precios');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <footer className="bg-navy-900" data-id="element-28">
      {/* Final CTA Section */}
      <section className="py-20 md:py-28 border-b border-navy-700" data-id="element-29">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-30">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} data-id="element-31">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-4" data-id="element-32">
              Transformá tu forma de{' '}
              <span className="text-gold-400" data-id="element-33">enseñar</span> hoy.
            </h2>
            <p className="text-lg md:text-xl text-gray-300 mb-8 max-w-2xl mx-auto" data-id="element-34">
              Accedé a los 13 tomos y empezá a disfrutar de tu tiempo libre
              mientras tus alumnos aprenden mejor.
            </p>

            {/* CTA Button */}
            <button onClick={scrollToPrecios} className="inline-flex items-center gap-3 bg-gradient-to-r from-gold-500 to-gold-600 hover:from-gold-400 hover:to-gold-500 text-navy-900 font-bold text-lg px-10 py-5 rounded-xl shadow-lg shadow-gold-500/25 hover:shadow-gold-500/40 transition-all duration-300 transform hover:scale-105" data-id="element-35">
              ¡Quiero mi pack ahora!
            </button>

            {/* Guarantee Badge */}
            <motion.div initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.3
          }} className="mt-10 inline-flex items-center gap-3 bg-navy-800/50 border border-navy-700 rounded-full px-6 py-3" data-id="element-36">
              <ShieldCheckIcon className="h-8 w-8 text-green-500" data-id="element-37" />
              <div className="text-left" data-id="element-38">
                <p className="text-white font-bold" data-id="element-39">Garantía de 7 días</p>
                <p className="text-gray-400 text-sm" data-id="element-40">
                  100% de devolución si no quedás satisfecho
                </p>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* Copyright Section */}
      <div className="py-8 px-4 sm:px-6 lg:px-8" data-id="element-41">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-42">
          {/* Logo */}
          <div className="flex items-center gap-2 text-white" data-id="element-43">
            <BookOpenIcon className="h-6 w-6 text-gold-500" data-id="element-44" />
            <span className="font-bold" data-id="element-45">
              <span className="text-gold-500" data-id="element-46">Megapack</span> Lengua y
              Literatura
            </span>
          </div>

          {/* Copyright */}
          <p className="text-gray-400 text-sm flex items-center gap-1" data-id="element-47">
            © 2026 Lengua y Literatura Lista. Hecho con{' '}
            <HeartIcon className="h-4 w-4 text-red-500 fill-red-500" data-id="element-48" /> para la
            comunidad educativa.
          </p>
        </div>
      </div>
    </footer>;
}